module.exports = __webpack_public_path__ + "static/media/signage-outdoor-img67.b4b4d61c.jpg";